import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  components: {
    HomeNavBar
  },
  computed: {
    active_membership_plans() {
      return this.membershipPlans.filter(plan => plan.is_active);
    },
    current_membership_label() {
      return this.current_membership?.membership_type?.name || this.current_membership?.name || '';
    },
    view_membership_loading() {
      return this.memberships_loading || this.payment_history_loading;
    },
    should_open_manage_subscription() {
      return this.$route.query.manage_subscription === '1';
    },
    selected_membership_plan() {
      if (this.selectedPlan === null || this.selectedPlan === '') {
        return null;
      }
      return this.active_membership_plans[this.selectedPlan] || null;
    }
  },
  mounted() {
    this.fetch_memberships();
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.filter_membership_payment_history();
  },
  data() {
    return ({
      user: this.getUserData(),
      currentStepIndex: 0,
      token_exists: false,
      steps: [
        { label: 'Membership' },
        { label: 'Payment' },
      ],
      selectedPlan: null,
      expandedPerks: {},
      memberships_loading: true,
      payment_history_loading: true,
      manage_subscription_opened: false,
      membershipPlans: [],
      current_membership: null,
      payfast: process.env.VUE_APP_PAYFAST_URL
    });
  },
  watch: {
    view_membership_loading(isLoading) {
      if (!isLoading) {
        this.open_manage_subscription_if_needed();
      }
    }
  },
  methods: {
    getUserData() {
      let user = {
        first_name: '',
        last_name: '',
        email: '',
        gender_id: '',
        date_of_birth: '',
        phone_number: '',
        user_id: '',
        newSkill: ''
      }
      return user;
    },
    getToken() {
      return get_token();
    },
    format_currency(amount) {
      const value = Number(amount || 0);
      return `R${value.toFixed(2)}`;
    },
    get_payment_status(payment) {
      return String(payment?.payment_status?.status || '').toLowerCase();
    },
    resolve_current_membership(history = []) {
      const currentEntry =
        history.find((payment) => this.get_payment_status(payment) === 'paid');
      return currentEntry?.membership || null;
    },
    has_matching_id(candidate_id, current_membership_id) {
      return Boolean(candidate_id && current_membership_id && candidate_id === current_membership_id);
    },
    has_same_membership_id(plan) {
      return this.has_matching_id(plan?.id, this.current_membership?.id);
    },
    has_same_membership_type(plan) {
      return this.has_matching_id(plan?.membership_type?.id, this.current_membership?.membership_type?.id);
    },
    has_same_billing_cycle(plan) {
      return this.has_matching_id(plan?.billing_cycle?.id, this.current_membership?.billing_cycle?.id);
    },
    has_same_membership_terms(plan) {
      return this.has_same_membership_type(plan) && this.has_same_billing_cycle(plan);
    },
    is_current_plan(plan) {
      return this.has_same_membership_id(plan) || this.has_same_membership_terms(plan);
    },
    is_upgrading_membership() {
      return Boolean(
        this.current_membership &&
        this.selected_membership_plan &&
        !this.is_current_plan(this.selected_membership_plan)
      );
    },
    get_membership_payment_url() {
      const endpoint = this.is_upgrading_membership()
        ? 'upgrade_membership'
        : 'create_payfast_membership_payment';

      return `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/${endpoint}/`;
    },
    resolve_upgraded_membership(response_data = {}) {
      return (
        response_data?.upgraded_membership?.membership
      );
    },
    get_upgrade_success_message(response = {}) {
      return response?.message;
    },
    get_payment_form_data(response = {}) {
      return response?.data_array || {};
    },
    submit_payfast_form(data_array = {}) {
      var form = $('#payment_form');
      for (var [key, value] of Object.entries(data_array)) {
        var input = $('#input_clone').clone();
        input.attr('name', key);
        input.attr('value', value);
        input.removeAttr('id');
        input.removeClass('d-none');
        form.append(input);
      }
      Swal.fire({
        title: 'Success',
        icon: 'success',
        text: "Redirecting to PayFast in a few seconds don't close this page",
        confirmButtonText: 'Ok',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      form.submit();
    },
    show_upgrade_success_message(message) {
      Swal.fire({
        title: 'Success',
        icon: 'success',
        text: message || 'Membership upgraded successfully.',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    },
    reset_to_membership_step() {
      this.currentStepIndex = 0;
      this.selectedPlan = null;
    },
    handle_membership_payment_success(response) {
      if (this.is_upgrading_membership()) {
        this.current_membership = this.resolve_upgraded_membership(response?.data || {});
        this.userHasPaid = true;
        this.reset_to_membership_step();
        this.show_upgrade_success_message(this.get_upgrade_success_message(response));
        return;
      }

      if (!response.success) {
        return;
      }

      this.submit_payfast_form(this.get_payment_form_data(response));
    },
    get_visible_perks(plan) {
      const perks = plan?.membership_perks || [];
      return Reflect.get(this.expandedPerks, plan.id) ? perks : perks.slice(0, 5);
    },
    toggle_perks(planId) {
      const expanded_perks = { ...this.expandedPerks };
      const current_value = Boolean(Reflect.get(this.expandedPerks, planId));
      Reflect.set(expanded_perks, planId, !current_value);
      this.expandedPerks = expanded_perks;
    },
    open_manage_subscription_if_needed() {
      if (!this.should_open_manage_subscription || !this.current_membership || this.manage_subscription_opened) {
        return;
      }
      this.manage_subscription_opened = true;
      $('#manage_subscription_modal').modal('show');
    },
    selectPlan(index) {
      this.selectedPlan = index;
      this.nextStep();
    },
    selectPaymentMethod(index) {
      this.selectedPaymentMethod = index;
    },
    nextStep() {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.currentStepIndex++;
      }
    },
    prevStep() {
      if (this.currentStepIndex > 0) {
        this.currentStepIndex--;
      }
    },
    cancel() {
      // Navigate back to customer profile page
      this.$router.push('/profile');
    },
    completePayment() {
      if (!this.selected_membership_plan) {
        Swal.fire({
          title: 'Please select a plan before proceeding.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const membership_id = this.selected_membership_plan.id;

      $.ajax({
        url: this.get_membership_payment_url(),
        method: 'POST',
        data: JSON.stringify({
          membership_id: membership_id,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          this.handle_membership_payment_success(response);
        },
        error: (error) => {
          console.error('AJAX error:', error);
          Swal.fire({
            title: 'Error',
            text: 'Payment failed. Please try again later.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    fetch_memberships() {
      this.token_exists = get_token();

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify({ is_active: true }),
        success: (response) => {
          this.membershipPlans = response.data.memberships;


        },
        complete: () => {
          this.memberships_loading = false;
        },
      });
    },

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {

        this.user.user_id = this.user_details.user_id;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify({ user_id: this.user.user_id }),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.current_membership = this.resolve_current_membership(this.membership_payment_history);

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => this.get_payment_status(payment) === "paid"
          );

          this.is_active = this.membership_payment_history[0]?.is_active || false;
          this.membership_payment_history_id = this.membership_payment_history[0]?.id || null;
          this.membership_name = this.membership_payment_history[0]?.membership?.name || '';
          this.membership_type = this.membership_payment_history[0]?.membership?.membership_type.name || '';
          this.billing_cycle = this.membership_payment_history[0]?.membership?.billing_cycle?.name || '';
          this.membership_price = this.membership_payment_history[0]?.membership?.membership_pricing[0]?.price || 0;
          this.renewal_date = this.membership_payment_history[0]?.valid_until || null;
        },
        complete: () => {
          this.payment_history_loading = false;
        },
      })
    },
    go_back() {
            this.$router.back();
        },
  }
}
